import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { DxDateTime } from "../../dx-core/utiles/dx-core-datetime-utils";
import { PitAgreementTaskResult } from "./pit-agreement-task-result";
import { PitBpmProcessInstance } from "../../pit-shared/domain/pit-bpm-process-instance";
/**
 * Задача в модуле "Согласование"
 * Может быть заполнена полностью или частично
 **/
let PitAgreementTask = class PitAgreementTask {
    /**
     * Задача в модуле "Согласование"
     * Может быть заполнена полностью или частично
     **/
    constructor() {
        /**
         * Список позможных вариантов завершения экземпляра задачи.
         */
        this.possibleResults = [];
    }
    getItemDescription() {
        return "";
    }
    getItemIcon() {
        return "";
    }
    getItemId() {
        return this.id;
    }
    getItemIdent() {
        return this.code;
    }
    getItemOrd() {
        return 0;
    }
    getItemSearchString() {
        const str = this.getItemTitle() + ' ' +
            this.getTaskText() + ' ' +
            this.getPlannedEndDate();
        return str.toLocaleLowerCase();
    }
    getItemTitle() {
        return this.code + ' ' + this.name;
    }
    canExecuteToolbarAction(action) {
        return false;
    }
    getAssignee() {
        return "";
    }
    getSupervisor() {
        return "";
    }
    getStatus() {
        return "";
    }
    getStartDate() {
        return null;
    }
    getEndDate() {
        return null;
    }
    getTaskText() {
        return this.contentCaption;
    }
    getPlannedEndDate() {
        return DxDateTime.dateTimeToStr(this.planningFinishDateTime, DxDateTime.dateTimeFormats.datetime);
    }
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], PitAgreementTask.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: PitBpmProcessInstance, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", PitBpmProcessInstance)
], PitAgreementTask.prototype, "processInstance", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "code", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "assigneeEmail", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], PitAgreementTask.prototype, "assigneeId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "assigneeLogin", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "assigneeName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "assigneePosition", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "contentCaption", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "contentUrl", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "description", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "resultCompletedCaption", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTask.prototype, "comment", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Date)
], PitAgreementTask.prototype, "startDateTime", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Date)
], PitAgreementTask.prototype, "planningFinishDateTime", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitAgreementTask.prototype, "finishDateTime", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitAgreementTaskResult, { emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitAgreementTask.prototype, "possibleResults", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Boolean)
], PitAgreementTask.prototype, "isActive", void 0);
PitAgreementTask = tslib_1.__decorate([
    jsonObject()
], PitAgreementTask);
export { PitAgreementTask };
